import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import ArticleTypesModal from './ArticleTypesModal';
import { Pagination } from '@mui/material';
import swal from 'sweetalert';

const ArticleTypes = () => {
    const childRef = useRef();
    const [articleTypes, setArticleTypes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadArticleTypes, setArticleTypeLoading] = useState(false);

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getArticleTypes').then((res) => {
            if (res.data && res.data.data) {
                setArticleTypes(res.data.data);
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Error fetching Article Types");
        });
    }, [loadArticleTypes]);

    const pageSize = 20;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = articleTypes?.slice(firstIndex, lastIndex);

    const npage = Math.ceil(articleTypes?.length / pageSize);
    const number = [...Array(npage + 1).keys()].slice(1);

    const handleDelete = (sn) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Article Type!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.delete(`${BACKEND_SERVER_URL}/deleteArticleType/${sn}`).then((res) => {
                    toast.success(res.data.message);
                    setArticleTypeLoading(!loadArticleTypes);
                }).catch((error) => {
                    toast.error(error.response?.data?.message || "Error deleting Article Type");
                });
            }
        });
    };

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title p-2 mb-2">
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className='col-sm-6 d-flex justify-content-start'>
                                        <button type="button" className="btn btn-dark btn-sm me-2 w-25"
                                            onClick={() => childRef.current.openModal()}
                                        >
                                            + Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">
                                <div className='dataTables_info text-dark'>
                                    Records: {articleTypes.length}
                                </div>
                                {articleTypes.length > pageSize ?
                                    <div className="dataTables_paginate paging_simple_numbers justify-content-center mb-0 pt-2">
                                        <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                    </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }}>
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className='custom-table-header p-2'>Sl.No.</th>
                                                <th className='p-2 text-start custom-table-header'>STATUS</th>
                                                <th className='text-start custom-table-header p-2'>ARTICLE TYPE</th>
                                                <th className='p-2 custom-table-header'>ACTIONS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 === 1 ? 'custom row-height' : 'row-height'}`}>
                                                    <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="sn-font-weight mb-0">{ind + 1 + firstIndex}</h6>
                                                    </td>
                                                    <td className='text-start p-1 active-col-width' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        {item.Status === 1 ? <h6 className="text-success mb-0">Active</h6> : <h6 className="text-danger mb-0">Inactive</h6>}
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <h6 className='mb-0' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Type}</h6>
                                                    </td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "100px" }}>
                                                        <CiEdit cursor='pointer' title='Edit Article Type' size={20} className='text-primary mx-2' onClick={() => childRef.current.openModal(item)} />
                                                        <MdDeleteOutline color='red' title='Delete Article Type' cursor='pointer' size={20} className='mx-2' onClick={() => handleDelete(item.Sn)} />
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            No Article Types Found
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ArticleTypesModal ref={childRef} loadArticleTypes={loadArticleTypes} setArticleTypeLoading={setArticleTypeLoading} />
        </>
    );
}

export default ArticleTypes;
